import { Directive, ElementRef, Renderer, OnChanges, Input } from '@angular/core';

@Directive({
  selector: '[appRowColor]'
})
export class RowColorDirective implements OnChanges{

  constructor(private _element: ElementRef, private _renderer: Renderer) { }

  @Input() appRowColor: string | number;

  ngOnChanges(){
    switch(this.appRowColor){
      case '1':
        this._renderer.setElementClass(this._element.nativeElement, 'green-600', true);
        break;
      case '2':
        this._renderer.setElementClass(this._element.nativeElement, 'yellow-600', true);
        break;
      case '3':
        this._renderer.setElementClass(this._element.nativeElement, 'warn-500', true);
        break;
      case 'Inactivo':
        this._renderer.setElementClass(this._element.nativeElement, 'warn-500', true);
        break;
      case 0: 
        this._renderer.setElementClass(this._element.nativeElement, 'warn-500', true);
        break;
    }
  }

}
